import React, { useEffect, useState, useRef } from "react";
import { fabric } from "fabric";
import { v4 as uuidv4 } from 'uuid';
import { AvField, AvForm } from "availity-reactstrap-validation"
import Select from "react-select";
import location from "assets/images/location.png"
import arrow from "assets/images/arrow.png"
import building from "assets/images/building-icon.png"
import { useDispatch, useSelector } from "react-redux"
import { appendData } from "store/Mode/actions"
import { toast } from "react-toastify";
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Label } from 'reactstrap'
import ShapeImgModal from "../ShapeImgModal"
import Shape from "../Shape"
import "./style.scss";
import AddToBuildingModal from "../AddToBuildingModal";
import BuildingService from "services/Admin/BuildingService";
import { SuccessCreated, SuccessOk } from "configs/statusCode";
import UploadUnitImagesModal from "../UploadUnitImagesModal";
import UploadMainImageModal from "../UploadMainImageModal";
import InterActiveModeService from "services/SalesDeveloper/InterActiveModeService";
import PropertyService from "services/Admin/PropertyService";

const shapes = [
    { value: 'Circle', label: 'Circle' },
    { value: 'Rect', label: 'Rect' },
    { value: 'Cubic', label: 'Cubic' },
    { value: 'node', label: 'node' },
    { value: 'Pin', label: 'Pin' },
    { value: 'Arrow', label: 'Arrow' },
    { value: 'Build', label: 'Build' },
]

const FabricCanvas = ({ setHeaderList, headerList, addSelectedUnit, buildingErrors, setBuildingErrors }) => {
    const [hotspots, setHotspots] = useState([])
    const [unitHotspot, setUnitHotspot] = useState([])
    const [defaultHotspots, setDefaultHotspots] = useState([])
    const [defaultUnitHotspot, setDefaultUnitHotspot] = useState([])
    const [selectedAll, setSelectedAll] = useState(false)
    const [changeType, setChangeType] = useState(false)
    const [addToBuildingModal, setAddToBuildingModal] = useState(false)
    const [unitsInLayer, setUnitsInLaye] = useState([])
    const [dropdownMasterOpen, setDropdownMasterOpen] = useState(false)
    const [shapeDropdownOpen, setShapeDropdownOpen] = useState(false)
    const [layer, setLayer] = useState(false)
    const dispatch = useDispatch()
    const [show, setShow] = useState(false)
    const [uploadUnitImagesModal, setUploadUnitImagesModal] = useState(false)
    const [uploadMainImageModal, setUploadMainImageModal] = useState(false)
    const toggleUnitModal = () => setUploadUnitImagesModal(prevState => !prevState)
    const toggleMaster = () => setDropdownMasterOpen(prevState => !prevState)
    const toggleAddToBuildingModal = () => setAddToBuildingModal(prevState => !prevState)
    const toggleUploadMainModal = () => setUploadMainImageModal(prevState => !prevState)
    const shapeToggle = () => setShapeDropdownOpen(prevState => !prevState)

    const modeData = useSelector(state => state.Mode)
    const [shouldGetData, setShouldGetData] = useState(false);
    const [canvas, setCanvas] = useState('');
    const [titles, setTitles] = useState([]);
    const [shapeData, setShapeData] = useState(null);
    const [changedShape, setChangedShape] = useState(null);
    const [activeCanvasData, setActiveCanvasData] = useState({
        id: "",
        path: "",
        shapes: []
    })
    const myStateRef = useRef(activeCanvasData)

    useEffect(() => {
        if(!headerList.length || activeCanvasData?.constrains?.type === 'none'){
            
            new InterActiveModeService().getBuildingUnit(modeData.compound.value).then(res => {
                const buildings = res?.data?.buildings?.map(item => {
                    return {
                        name: `${item.name?.en}`,
                        label: `${item.name?.en} / Building`,
                        value: `${item.id} / Building`,
                        id: item.id,
                        type: "building"
                    }
                })
                const units = res?.data?.units?.map(item => {
                    return {
                        name: `${item.name.en}`,
                        label: `${item.name.en} / ${item.unit_type}`,
                        value: `${item.id}/ ${item.unit_type}`,
                        id: item.id,
                        type: "unit",
                        check: 'standAlone',
                        floor: item.floors_num
                    }
                })
                if(activeCanvasData?.constrains?.type === 'none'){
                    let updateBuilding = buildings?.filter(build=> !modeData?.images?.some(img=> img.title == build.name))
                    let updateUnits = units?.filter(build=> !modeData?.images?.some(img=> img.title == build.name))
                    setHotspots([{
                        label: "None",
                        value: "none",
                        type: "none"
                    }, ...updateBuilding, ...updateUnits])
                    setDefaultHotspots([{
                        label: "None",
                        value: "none",
                        type: "none"
                    }, ...updateBuilding, ...updateUnits])
                    return
                }
                setHotspots([{
                    label: "None",
                    value: "none",
                    type: "none"
                }, ...units, ...buildings])
                setDefaultHotspots([{
                    label: "None",
                    value: "none",
                    type: "none"
                }, ...units, ...buildings])
            })
        }
    }, [shouldGetData, activeCanvasData.constrains])

    useEffect(() => {
        if (modeData) {
            const activeImage = modeData.images.find(item => item.id === modeData.currentImge.id)
            let hotspotList = []
            activeImage.shapes.forEach(shape => {
                if (shape ?.hotspot ?.type ) {
                    hotspotList.push(shape.hotspot)
                }
            })

            const updatedList1 = defaultHotspots.filter(({ value }) => !hotspotList.some(item => item ?.value === value))
            setHotspots([...updatedList1])

            const updatedList2 = defaultUnitHotspot.filter(({ value }) => !hotspotList.some(item => item ?.value === value))
            setUnitHotspot([...updatedList2])
        }

    }, [defaultHotspots, defaultUnitHotspot]);

    useEffect(() => {
        //&& activeCanvasData ?.constrains.type == 'building'
        if (!!activeCanvasData ?.constrains ?.id){
            propertyService.getDropDown(activeCanvasData ?.constrains ?.id, "Left").then((res) => {
                const options = res.data.map(item => {
                    return {
                        name: `${item.name.en}`,
                        label: `${item.name.en} / ${item.unit_type}`,
                        value: item.id,
                        type: "unit",
                        id: item.id,
                        check: 'inBuilding',
                        floor: item.floors_num
                    }
                })

                // if i need make units in layer doesn't duplicate
                if(activeCanvasData.constrains?.type !== 'building'){
                    let layers = modeData.images.filter(item => item.id == activeCanvasData.comesForm.id)[0]?.shapes
                    let units = []
                    layers?.map(layer => {
                        modeData?.images.map(img=> {
                            if(img.id == layer.idImage.id){
                                let shapes = img.shapes?.map(item => item.hotspot)
                                units.push(...shapes) 
                            }
                        })
                    })
                    let update = options.filter(opt => !units.some(unit => unit.id == opt.id))
                    setUnitHotspot(update)
                    setDefaultUnitHotspot(update)
                } else{
                    setUnitHotspot(options)
                    setDefaultUnitHotspot(options)
                }
                // setUnitHotspot(options)
                // setDefaultUnitHotspot(options)
            })
        }
    }, [activeCanvasData ?.constrains, shouldGetData])

    const propertyService = new PropertyService()

    const customizeTypes = (constrains) => {
        let result = false
        if (constrains ?.type === "none" || !constrains ?.type ) {
            result = true
        }
        return result
    }

    useEffect(() => {
        if (modeData) {
            const activeImage = modeData.images.find(item => item.id === modeData.currentImge.id)
            setActiveCanvasData({
                id: activeImage.id,
                path: activeImage.path,
                shapes: activeImage.shapes,
                constrains: activeImage.constrains,
                comesForm: activeImage.comesForm,
            })
        }
    }, [])

    useEffect(() => {
        myStateRef.current = activeCanvasData
        if (activeCanvasData ?.path?.length !== 0) {
            const isExist = modeData?.images?.find(item => activeCanvasData?.id === item?.id)
            let updatedModeData

            if (isExist) {
                updatedModeData = modeData?.images?.map(img => {
                    if (img?.id === activeCanvasData?.id) {
                        return {
                            ...img,
                            shapes: [...activeCanvasData.shapes],
                        }
                    } else {
                        return img
                    }
                })
                if(changedShape?.hotspot?.type == 'unit'){
                    updatedModeData = updatedModeData?.map(img=>{
                        if(img?.constrains?.id === changedShape?.hotspot?.id){
                            return{
                                ...img,
                                id: changedShape?.idImage?.id,
                                path: changedShape?.idImage?.path
                            }
                        } else{
                            return {...img}
                        }
                    })
                } else if(changedShape?.hotspot?.type == 'layer'){
                    let shapeItem = modeData?.images?.find(item => changedShape?.hotspot?.id === item?.constrains?.id && changedShape?.hotspot?.type === item?.constrains?.type)

                    updatedModeData = updatedModeData?.filter(item1=>{
                        return !shapeItem?.shapes?.some((item2) => item1?.id === item2?.idImage?.id && item1?.constrains?.id === item2?.hotspot?.id);
                    })?.filter(res=> res?.id !== shapeItem?.id)
                } else if(changedShape?.hotspot?.type == 'building'){
                    let shapeItem = modeData?.images?.find(item => changedShape?.hotspot?.id === item?.constrains?.id && changedShape?.hotspot?.type === item?.constrains?.type)
                    if(shapeItem?.shapes?.length > 0 && shapeItem?.shapes[0]?.hotspot?.type === 'layer'){
                        let layerIds = shapeItem?.shapes?.map(shape=> shape?.idImage?.id)
                        let ids = []
                        modeData?.images?.filter(img=>{
                            return layerIds?.some(layer=> layer === img?.id)
                        })?.map(unit=> unit?.shapes?.map(shape=> ids?.push(shape?.idImage?.id)))

                        updatedModeData = updatedModeData?.filter(item1=>{
                                return ![...layerIds, ...ids]?.some((item2) => item1?.id === item2);
                        })?.filter(res=> res?.id !== shapeItem?.id)
                    } else {
                        updatedModeData = updatedModeData?.filter(item1=>{
                            return !shapeItem?.shapes?.some((item2) => item1?.id === item2?.idImage?.id);
                        })?.filter(res=> res?.id !== shapeItem?.id)
                    }
                }

                setChangedShape(null)
            } else {
                updatedModeData = [...modeData.images, {
                    id: activeCanvasData.id,
                    path: activeCanvasData.path,
                    shapes: []
                }]
            }
            dispatch(appendData({
                ...modeData,
                currentImge: {
                    id: activeCanvasData.id,
                    path: activeCanvasData.id,
                },
                // previousImg:activeCanvasData.previousImg,
                images: [...updatedModeData]
            }
            ))
        }
        let hotspotList = []
        activeCanvasData.shapes.forEach((shape) => {
            if (shape ?.hotspot ?.type != "none") {
                hotspotList.push(shape.hotspot)
            }

        })
        activeCanvasData.shapes.forEach((shape, index) => {
            if(shape.hotspot?.value == 'layer'){
                setLayer(true)
            } else {
                setLayer(false)
            }
            return
        })
        if(activeCanvasData.shapes?.length == 0) setLayer(false)
        
        if (customizeTypes(activeCanvasData ?.constrains )) {
            const updatedList = defaultHotspots.filter((value) => !activeCanvasData.shapes.some(item => item ?.hotspot?.name === value.name))
            setHotspots([...updatedList])
        } else {
            let updatedList = defaultUnitHotspot.filter(({ value }) => !hotspotList.some(item => item ?.value === value))
            if(activeCanvasData.shapes.length > 0 && !layer){
                setUnitHotspot([...updatedList])
            } else {
                setUnitHotspot([{label:'Layer', value: 'layer', name: 'layer', type: 'layer', id: activeCanvasData?.constrains?.id},...updatedList])
            }
        }

        // let updateActiveCanvasData = activeCanvasData.shapes?.map(data=> {
        //     let hotspot = {...data?.hotspot}
        //     if(data?.hotspot?.value == 'addBuilding'){
        //         hotspot = {...data?.hotspot, name: data.title}
        //     }
        //     return {...data, hotspot}
        // })
    }, [activeCanvasData, shapeData])

    // if i need make units in layer doesn't duplicate
    useEffect(()=>{
        if(activeCanvasData?.constrains?.value == 'layer'){
            let updatedUnit = [...unitsInLayer ,...defaultUnitHotspot.filter(({ value }) => activeCanvasData.shapes.some(obj2 => obj2.hotspot.value == value ))];
            const uniqueArray = Array.from(new Set(updatedUnit.map(JSON.stringify)), JSON.parse);
            setUnitsInLaye([...uniqueArray])
        }
    },[activeCanvasData])

    const initCanvas = () => {
        const canvas = new fabric.Canvas(`canvas`)
        canvas.setDimensions({ width: 661.5, height: 398 })
        new fabric.Image.fromURL(activeCanvasData ?.path, function (img) {
            canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
                scaleX: canvas.width / img.width,
                scaleY: canvas.height / img.height,
                backgroundImageStretch: true
            });
        })

        canvas.on('selection:created', function (e) {
            const updatedShapes = myStateRef ?.current ?.shapes ?.map(shape => {
                if (shape.id === e.target.id) {
                    return {
                        ...shape,
                        next: true
                    }
                } else {
                    return {
                        ...shape,
                        next: false
                    }
                }
            }) 
            setActiveCanvasData({
                ...myStateRef.current,
                shapes: [...updatedShapes]
            })
        })
        canvas.on('selection:updated', function (e) {
            const updatedShapes = myStateRef ?.current ?.shapes ?.map(shape => {
                if (shape.id === e.target.id) {
                    return {
                        ...shape,
                        next: true
                    }
                } else {
                    return {
                        ...shape,
                        next: false
                    }
                }

            }) 
            setActiveCanvasData({
                ...myStateRef.current,
                shapes: [...updatedShapes]
            })

        })
        canvas.on('selection:cleared', function (e) {
            // const updatedShapes = myStateRef ?.current ?.shapes ?.map(shape => {

            //     return {
            //         ...shape,
            //         // next: false
            //     }

            // }) 
            // setActiveCanvasData({
            //     ...myStateRef.current,
            //     shapes: [...updatedShapes]
            // })

        })
        canvas.on('object:added', function (e) {
            let shape = {}
            if (e.target.type === "Circle") {
                shape = {
                    idImage: e.target.idImage,
                    id: e.target.id,
                    type: "Circle",
                    radius: e.target.radius,
                    fill: e.target.fill,
                    left: e.target.left,
                    top: e.target.top,
                    stroke: e.target.stroke,
                    strokeWidth: e.target.strokeWidth,
                    title: e.target.title,
                    selectedShape: e.target.selectedShape,
                    hotspot: e.target.hotspot,
                    highlight: false,
                    zoomX: e.target.zoomX,
                    zoomY: e.target.zoomY,
                    scaleX: e.target.scaleX,
                    scaleY: e.target.scaleY,
                    aCoords: e.target.aCoords,
                    angle: e.target.angle,
                    strokeDashArray: [10, 10],
                    next: false,
                    // lineCoords:e.target.lineCoords,
                }
            } else if (e.target.type === "Rect") {
                shape = {
                    idImage: e.target.idImage,
                    id: e.target.id,
                    type: "Rect",
                    left: e.target.left,
                    top: e.target.top,
                    stroke: e.target.stroke,
                    strokeWidth: e.target.strokeWidth,
                    fill: e.target.fill,
                    width: e.target.width,
                    height: e.target.height,
                    title: e.target.title,
                    selectedShape: e.target.selectedShape,
                    hotspot: e.target.hotspot,
                    highlight: false,
                    zoomX: e.target.zoomX,
                    zoomY: e.target.zoomY,
                    scaleX: e.target.scaleX,
                    scaleY: e.target.scaleY,
                    lineCoords: e.target.lineCoords,
                    angle: e.target.angle,
                    aCoords: e.target.aCoords,
                    strokeDashArray: [10, 10],
                    next: false
                }
            } else if (e.target.type === "Cubic") {
                shape = {
                    idImage: e.target.idImage,
                    id: e.target.id,
                    type: "Cubic",
                    left: e.target.left,
                    top: e.target.top,
                    opacity: e.target?.opacity,
                    stroke: e.target.stroke,
                    strokeWidth: e.target.strokeWidth,
                    fill: e.target.fill,
                    width: e.target.width,
                    height: e.target.height,
                    title: e.target.title,
                    selectedShape: e.target.selectedShape,
                    hotspot: e.target.hotspot,
                    highlight: false,
                    zoomX: e.target.zoomX,
                    zoomY: e.target.zoomY,
                    scaleX: e.target.scaleX,
                    scaleY: e.target.scaleY,
                    lineCoords: e.target.lineCoords,
                    angle: e.target.angle,
                    aCoords: e.target.aCoords,
                    // strokeDashArray: [10, 10],
                    next: false
                }
            } else if (e.target.type === "Pin") {
                shape = {
                    idImage: e.target.idImage,
                    type: "Pin",
                    left: e.target.left,
                    top: e.target.top,
                    angle: e.target.angle,
                    id: e.target.id,
                    title: e.target.title,
                    selectedShape: e.target.selectedShape,
                    hotspot: e.target.hotspot,
                    highlight: false,
                    zoomX: 1,
                    zoomY: 1,
                    scaleX: e.target.scaleX,
                    scaleY: e.target.scaleY,
                    aCoords: e.target.aCoords,
                    angle: e.target.angle,
                    next: false
                }
            } else if (e.target.type === "Arrow") {
                shape = {
                    idImage: e.target.idImage,
                    type: "Arrow",
                    left: e.target.left,
                    top: e.target.top,
                    angle: e.target.angle,
                    id: e.target.id,
                    title: e.target.title,
                    selectedShape: e.target.selectedShape,
                    hotspot: e.target.hotspot,
                    highlight: false,
                    padding: 0,
                    zoomX: 1,
                    zoomY: 1,
                    scaleX: e.target.scaleX,
                    scaleY: e.target.scaleY,
                    aCoords: e.target.aCoords,
                    angle: e.target.angle,
                    next: false
                }
            } else if (e.target.type === "Build") {
                shape = {
                    idImage: e.target.idImage,
                    type: "Build",
                    left: e.target.left,
                    top: e.target.top,
                    angle: e.target.angle,
                    id: e.target.id,
                    title: e.target.title,
                    selectedShape: e.target.selectedShape,
                    hotspot: e.target.hotspot,
                    highlight: false,
                    zoomX: 1,
                    zoomY: 1,
                    scaleX: e.target.scaleX,
                    scaleY: e.target.scaleY,
                    aCoords: e.target.aCoords,
                    angle: e.target.angle,
                    next: false
                }
            } else if (e.target.type === "node") {
                shape = {
                    idImage: e.target.idImage,
                    id: e.target.id,
                    type: "node",
                    left: e.target.left,
                    opacity: e.target?.opacity,
                    fill: e.target?.fill,
                    top: e.target.top,
                    title: e.target.title,
                    selectedShape: e.target.selectedShape,
                    hotspot: e.target.hotspot,
                    highlight: false,
                    zoomX: e.target.zoomX,
                    zoomY: e.target.zoomY,
                    scaleX: e.target.scaleX,
                    scaleY: e.target.scaleY,
                    aCoords: e.target.aCoords,
                    angle: e.target.angle,
                    next: e.target.next
                }
            }

            const isExist = myStateRef.current.shapes.find(item => item.id === e.target.id)

            if (isExist) {
                const updatedShapesData = myStateRef.current.shapes.map((item, index) => {
                    if (item.id === isExist.id) {
                        return shape
                    } else {
                        return item
                    }
                })
                setActiveCanvasData({
                    ...myStateRef.current,
                    shapes: [...updatedShapesData.map((item, index) => {
                        if (index == 0) {
                            return {...item, next: true, highlight: false}
                        } else {
                            return {...item, next: false, highlight: false}
                        }
                    })]

                })
            } else {
                setActiveCanvasData({
                    ...myStateRef.current,
                    shapes: [...myStateRef.current.shapes,shape]

                })
            }

        })

        canvas.on('object:modified', function (e) {
            const updatedShapes = myStateRef ?.current ?.shapes ?.map(shape => {
                if (shape.id === e.target.id) {
                    if (e.target.type === "Circle") {
                        return {
                            idImage: shape.idImage,
                            id: e.target.id,
                            type: "Circle",
                            radius: e.target.radius,
                            fill: e.target.fill,
                            left: e.target.left,
                            top: e.target.top,
                            stroke: e.target.stroke,
                            strokeWidth: e.target.strokeWidth,
                            title: shape.title,
                            selectedShape: shape.selectedShape,
                            hotspot: shape.hotspot,
                            highlight: shape.highlight,
                            zoomX: e.target.zoomX,
                            zoomY: e.target.zoomY,
                            scaleX: e.target.scaleX,
                            scaleY: e.target.scaleY,
                            aCoords: e.target.aCoords,
                            angle: e.target.angle,
                            lineCoords:e.target.lineCoords,
                            strokeDashArray: [10, 10],
                            next: shape?.next

                        }
                    } else if (e.target.type === "Rect") {
                        return {
                            idImage: shape.idImage,
                            id: e.target.id,
                            type: "Rect",
                            left: e.target.left,
                            top: e.target.top,
                            stroke: e.target.stroke,
                            strokeWidth: e.target.strokeWidth,
                            fill: e.target.fill,
                            width: e.target.width,
                            height: e.target.height,
                            title: shape.title,
                            selectedShape: shape.selectedShape,
                            hotspot: shape.hotspot,
                            highlight: shape.highlight,
                            zoomX: e.target.zoomX,
                            zoomY: e.target.zoomY,
                            scaleX: e.target.scaleX,
                            scaleY: e.target.scaleY,
                            lineCoords: e.target.lineCoords,
                            angle: e.target.angle,
                            aCoords: e.target.aCoords,
                            strokeDashArray: [10, 10],
                            next: shape?.next
                        }
                    } else if (e.target.type === "Cubic") {
                        return {
                            idImage: shape.idImage,
                            id: e.target.id,
                            type: "Cubic",
                            left: e.target.left,
                            top: e.target.top,
                            stroke: shape.fill,
                            strokeWidth: e.target.strokeWidth,
                            opacity: shape?.opacity,
                            fill: shape.fill,
                            width: e.target.width,
                            height: e.target.height,
                            title: shape.title,
                            selectedShape: shape.selectedShape,
                            hotspot: shape.hotspot,
                            highlight: shape.highlight,
                            zoomX: e.target.zoomX,
                            zoomY: e.target.zoomY,
                            scaleX: e.target.scaleX,
                            scaleY: e.target.scaleY,
                            lineCoords: e.target.lineCoords,
                            angle: e.target.angle,
                            aCoords: e.target.aCoords,
                            // strokeDashArray: [10, 10],
                            next: shape?.next
                        }
                    } else if (e.target.type === "Pin") {
                        return {
                            idImage: shape.idImage,
                            type: "Pin",
                            left: e.target.left,
                            top: e.target.top,
                            angle: e.target.angle,
                            id: e.target.id,
                            title: shape.title,
                            selectedShape: shape.selectedShape,
                            hotspot: shape.hotspot,
                            highlight: shape.highlight,
                            zoomX: e.target.zoomX,
                            zoomY: e.target.zoomY,
                            scaleX: e.target.scaleX,
                            scaleY: e.target.scaleY,
                            aCoords: e.target.aCoords,
                            angle: e.target.angle,
                            next: shape?.next
                        }
                    } else if (e.target.type === "Arrow") {
                        return {
                            idImage: shape.idImage,
                            type: "Arrow",
                            left: e.target.left,
                            top: e.target.top,
                            angle: e.target.angle,
                            id: e.target.id,
                            title: shape.title,
                            padding: 0,
                            selectedShape: shape.selectedShape,
                            hotspot: shape.hotspot,
                            highlight: shape.highlight,
                            zoomX: e.target.zoomX,
                            zoomY: e.target.zoomY,
                            scaleX: e.target.scaleX,
                            scaleY: e.target.scaleY,
                            aCoords: e.target.aCoords,
                            angle: e.target.angle,
                            next: shape?.next
                        }
                    } else if (e.target.type === "Build") {
                        return {
                            idImage: shape.idImage,
                            type: "Build",
                            left: e.target.left,
                            top: e.target.top,
                            angle: e.target.angle,
                            id: e.target.id,
                            title: shape.title,
                            selectedShape: shape.selectedShape,
                            hotspot: shape.hotspot,
                            highlight: shape.highlight,
                            zoomX: e.target.zoomX,
                            zoomY: e.target.zoomY,
                            scaleX: e.target.scaleX,
                            scaleY: e.target.scaleY,
                            aCoords: e.target.aCoords,
                            angle: e.target.angle,
                            next: shape?.next
                        }
                    } else if (e.target.type === "node") {
                        return {
                            idImage: shape.idImage,
                            id: e.target.id,
                            type: "node",
                            left: e.target.left,
                            top: e.target.top,
                            title: shape.title,
                            opacity: shape?.opacity,
                            fill: shape?.fill,
                            selectedShape: shape.selectedShape,
                            hotspot: shape.hotspot,
                            highlight: shape.highlight,
                            zoomX: e.target.zoomX,
                            zoomY: e.target.zoomY,
                            scaleX: e.target.scaleX,
                            scaleY: e.target.scaleY,
                            aCoords: e.target.aCoords,
                            angle: e.target.angle,
                            next: shape?.next
                        }
                    }
                } else {
                    return shape
                }
            })
            setActiveCanvasData({
                ...myStateRef.current,
                shapes: [...updatedShapes]
            })
        })
        canvas.requestRenderAll()

        activeCanvasData ?.shapes ?.forEach((shape, index) => {
            fabric.Object.prototype.controls.mtr.offsetY = -15
            if (shape.type === "Circle") {
                var circle = new fabric.Circle({
                    radius: 50,
                    fill: shape.fill,
                    // left: 0,
                    stroke: shape.stroke,
                    // top: 30,
                    strokeWidth: 1,
                    strokeDashArray: [10,10]
                });
                const shapeTitle = new fabric.Text(shape.title, {
                    left: circle.left,// + ((shape.aCoords.tr.x-shape.aCoords.tl.x ) / 2),
                    top: circle.top-7.5,
                    fontSize: 20,
                    fontWeight: '600',
                    originX: 'left',
                    originY: 'center',
                });
                shapeTitle.set('selectable', false)
                var group = new fabric.Group([circle,shapeTitle], { ...shape })
                canvas.add(group);
            } else if (shape.type === "Rect") {
                var rect = new fabric.Rect({
                    // ...shape
                    fill: shape.fill,
                    // left: 0,
                    stroke: shape.stroke,
                    // top: 30,
                    strokeWidth: 2,
                    strokeDashArray: [10,10],
                    width: shape.width,
                    height: shape.height,
                });
                const shapeTitle = new fabric.Text(shape.title, {
                    left: rect.left,// + ((shape.aCoords.tr.x-shape.aCoords.tl.x ) / 2),
                    top: rect.top+7.5,
                    fontSize: 20,
                    fontWeight: '600',
                    originX: 'left',
                    originY: 'center',
                });
                shapeTitle.set('selectable', false)
                var group = new fabric.Group([rect,shapeTitle], { ...shape })
                canvas.add(group);
            } else if (shape.type === "Cubic") {
                var rect = new fabric.Rect({
                    fill: shape.fill,
                    stroke: shape.stroke,
                    strokeWidth: 1,
                    width: shape.width,
                    height: shape.height,
                });
                const shapeTitle = new fabric.Text(shape.title, {
                    left: rect.left,
                    top: rect.top-7.5,
                    fontSize: 20,
                    fontWeight: '600',
                    originX: 'left',
                    originY: 'center'
                });
                shapeTitle.set('selectable', false)
                // canvas.add(shapeTitle);

                var group = new fabric.Group([rect,shapeTitle], { ...shape })
                canvas.add(group);
            } else if (shape.type === "Pin") {
                fabric.Image.fromURL(location, function (img) {
                    img.scale(0.1)
                    // .set({
                    //     ...shape
                    // })
                    const shapeTitle = new fabric.Text(shape.title, {
                        left: 0 ,//+ ((shape.aCoords.tr.x-shape.aCoords.tl.x ) / 2),
                        top: 0,
                        fontSize: 20,
                        fontWeight: '600',
                        originX: 'left',
                        originY: 'center',
                    });
                    var group = new fabric.Group([img,shapeTitle], { ...shape,  })
                    canvas.add(group)
                })
            } else if (shape.type === "Arrow") {
                fabric.Image.fromURL(arrow, function (img) {
                    img.scale(0.065)
                    // .set({
                    //     ...shape
                    // })
                    const shapeTitle = new fabric.Text(shape.title, {
                        left: 0 ,//+ ((shape.aCoords.tr.x-shape.aCoords.tl.x ) / 2),
                        top: -5,
                        fontSize: 20,
                        fontWeight: '600',
                        originX: 'left',
                        originY: 'center',
                    });
                    var group = new fabric.Group([img,shapeTitle], { ...shape,  })
                    canvas.add(group)
                })
            } else if (shape.type === "Build") {
                fabric.Image.fromURL(building, function (img) {
                    img.scale(0.1)
                    // .set({
                    //     ...shape
                    // })
                    const shapeTitle = new fabric.Text(shape.title, {
                        left: 0 ,//+ ((shape.aCoords.tr.x-shape.aCoords.tl.x ) / 2),
                        top: -5,
                        fontSize: 20,
                        fontWeight: '600',
                        originX: 'left',
                        originY: 'center',
                    });
                    var group = new fabric.Group([img,shapeTitle], { ...shape,  })
                    canvas.add(group)
                })
            } else {
                var node = new fabric.Circle({
                    radius: 20,
                    fill: shape.fill,
                    // left: 0,
                    stroke: shape.fill,
                    // top: 30,
                    strokeWidth: 1,
                });
                const shapeTitle = new fabric.Text( shape?.title , {
                    left: node.left,
                    top: node.top-10,
                    fontSize: 20,
                    fontWeight: '600',
                    originX: 'left',
                    originY: 'center',
                });
                shapeTitle.set('selectable', false)

                var group = new fabric.Group([node,shapeTitle], { ...shape,  })
                canvas.add(group);
            }
            canvas.renderAll();
        })
         
        return canvas
    }

    useEffect(() => {
        // var deleteIcon = "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Ebene_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='595.275px' height='595.275px' viewBox='200 215 230 470' xml:space='preserve'%3E%3Ccircle style='fill:%23F44336;' cx='299.76' cy='439.067' r='218.516'/%3E%3Cg%3E%3Crect x='267.162' y='307.978' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -222.6202 340.6915)' style='fill:white;' width='65.545' height='262.18'/%3E%3Crect x='266.988' y='308.153' transform='matrix(0.7071 0.7071 -0.7071 0.7071 398.3889 -83.3116)' style='fill:white;' width='65.544' height='262.179'/%3E%3C/g%3E%3C/svg%3E";
        var img = document.createElement('img');
        // img.src = deleteIcon;
        fabric.Object.prototype.transparentCorners = false;
        fabric.Object.prototype.borderColor = 'transparent';
        fabric.Object.prototype.cornerColor = '#2a3042';
        fabric.Object.prototype.cornerStyle = 'circle';
        fabric.Object.prototype.cornerSize = 10
        fabric.Object.prototype.controls.deleteControl = new fabric.Control({
            x: 0.5,
            y: -0.5,
            offsetY: 10,
            cursorStyle: 'pointer',
            // mouseUpHandler: deleteObject,
            render: renderIcon,
            cornerSize: 10
        });
        // function deleteObject(eventData, transform) {
        //     var target = transform.target;
        //     var canvas = target.canvas;
        //     canvas.remove(target);
        //     const updatedShapesData = myStateRef.current ?.shapes ?.filter(item => item.id !== target.id)
        //  setActiveCanvasData({
        //         ...myStateRef.current,
        //         shapes: updatedShapesData
        //     })
        //     canvas.requestRenderAll();
        // }
        function renderIcon(ctx, left, top, styleOverride, fabricObject) {
            var size = this.cornerSize;
            ctx.save();
            ctx.translate(left, top);
            ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
            ctx.drawImage(img, -size / 2, -size / 2, size, size);
            ctx.restore();
        }
    }, [])

    useEffect(() => {
        if (shapeData ?.selectedShape) {
            addShapeHandler({
                shapeType: shapeData ?.selectedShape ?.label
            })
        }
    }, [shapeData]);

    useEffect(() => {
        setCanvas(initCanvas());
        return () => {
            if (canvas) {
                canvas.clear()
                canvas.renderAll();
            }
        }
    }, [activeCanvasData.path])

    const addShapeHandler = (shape, idValue) => {
        let deletedItem
        if (idValue) deletedItem = activeCanvasData ?.shapes ?.find(item => item.id === idValue)

        if (shape.shapeType === "Circle") {
            const circle = {
                type: "Circle",
                radius: 50,
                fill: 'rgba(0,0,0,0)',
                top: deletedItem ? deletedItem ?.top : 0,
                left: deletedItem ? deletedItem ?.left : 0,
                stroke: "black",
                strokeWidth: 1,
                id: idValue ? deletedItem.id : uuidv4(),
                idImage: deletedItem ? deletedItem ?.idImage : null,
                title: deletedItem ? deletedItem ?.title : shapeData.title,
                selectedShape: deletedItem ? { label: shape.shapeType, value: shape.shapeType } : shapeData.selectedShape,
                hotspot: deletedItem ? deletedItem ?.hotspot : shapeData.hotspot,
                highlight: false,
                next: false,
                strokeDashArray: [10, 10]
            }
            var circleShape = new fabric.Circle(circle);
            const shapeTitle = new fabric.Text(circle.title, {
                left: circle.left,// + ((shape.aCoords.tr.x-shape.aCoords.tl.x ) / 2),
                top: circle.top - 7.5,
                fontSize: 20,
                fontWeight: '600',
                originX: 'left',
                originY: 'center',
            });
            shapeTitle.set('selectable', false)
            // canvas.add(shapeTitle);

            var group = new fabric.Group([circleShape,shapeTitle], { ...circle })
            canvas.add(group);
            if (idValue) {
                
                // const updatedShapesData = activeCanvasData ?.shapes ?.filter(item => item.id !== idValue)
                // setActiveCanvasData({
                //     ...activeCanvasData,
                //     shapes: [...updatedShapesData, circle]

                // })
                const updatedShapesData = activeCanvasData ?.shapes ?.map(item => {
                    if(item.id === idValue){
                        return {...circle}
                    } else {
                        return {...item}
                    }
                })

                setActiveCanvasData({
                    ...activeCanvasData,
                    shapes: [...updatedShapesData]

                })
            } else {
                setActiveCanvasData({
                    ...activeCanvasData,
                    shapes: [...activeCanvasData.shapes, circle]

                })
            }
        } else if (shape.shapeType === "Rect") {
            const reactShape = {
                type: "Rect",
                top: deletedItem ? deletedItem ?.top : 0,
                left: deletedItem ? deletedItem ?.left : 0,
                stroke: 'black',
                strokeWidth: 2,
                fill: "transparent",
                width: 100,
                height: 100,
                id: idValue ? deletedItem.id : uuidv4(),
                idImage: deletedItem ? deletedItem ?.idImage : null,
                title: deletedItem ? deletedItem ?.title : shapeData.title,
                selectedShape: deletedItem ? { label: shape.shapeType, value: shape.shapeType } : shapeData.selectedShape,
                hotspot: deletedItem ? deletedItem ?.hotspot : shapeData.hotspot,
                highlight: false,
                strokeDashArray: [10, 10],
                next: false
            }
            var rect = new fabric.Rect(reactShape);
            const shapeTitle = new fabric.Text(reactShape.title, {
                left: reactShape.left,// + ((shape.aCoords.tr.x-shape.aCoords.tl.x ) / 2),
                top: reactShape.top+7.5,
                fontSize: 20,
                fontWeight: '600',
                originX: 'left',
                originY: 'center',
            });
            shapeTitle.set('selectable', false)
            // canvas.add(shapeTitle);

            var group = new fabric.Group([rect,shapeTitle], { ...reactShape })
            canvas.add(group)
            if (idValue) {
                const updatedShapesData = activeCanvasData ?.shapes ?.map(item => {
                    if(item.id === idValue){
                        return {...reactShape}
                    } else {
                        return {...item}
                    }
                })
                setActiveCanvasData({
                    ...activeCanvasData,
                    shapes: [...updatedShapesData]

                })
            } else {
                setActiveCanvasData({
                    ...activeCanvasData,
                    shapes: [...activeCanvasData.shapes, reactShape]
                })
            }
        } else if (shape.shapeType === "Cubic") {
            const reactShape = {
                type: "Cubic",
                top: deletedItem ? deletedItem ?.top : 0,
                left: deletedItem ? deletedItem ?.left : 0,
                stroke: '#fd3d3d',
                strokeWidth: 1,
                fill: '#fd3d3d',
                opacity: 1,
                width: 100,
                height: 100,
                id: idValue ? deletedItem.id : uuidv4(),
                idImage: deletedItem ? deletedItem ?.idImage : null,
                title: deletedItem ? deletedItem ?.title : shapeData.title,
                selectedShape: deletedItem ? { label: shape.shapeType, value: shape.shapeType } : shapeData.selectedShape,
                hotspot: deletedItem ? deletedItem ?.hotspot : shapeData.hotspot,
                highlight: false,
                next: false
            }
            var rect = new fabric.Rect(reactShape);
            const shapeTitle = new fabric.Text(reactShape.title, {
                left: reactShape.left,// + ((shape.aCoords.tr.x-shape.aCoords.tl.x ) / 2),
                top: reactShape.top-10,
                fontSize: 20,
                fontWeight: '600',
                originX: 'left',
                originY: 'center',
            });
            shapeTitle.set('selectable', false)
            // canvas.add(shapeTitle);

            var group = new fabric.Group([rect,shapeTitle], { ...reactShape })
            canvas.add(group)
            if (idValue) {
                // const updatedShapesData = activeCanvasData ?.shapes ?.filter(item => item.id !== idValue)
                // setActiveCanvasData({
                //     ...activeCanvasData,
                //     shapes: [...updatedShapesData, reactShape]

                // })

                const updatedShapesData = activeCanvasData ?.shapes ?.map(item => {
                    if(item.id === idValue){
                        return {...reactShape}
                    } else {
                        return {...item}
                    }
                })

                setActiveCanvasData({
                    ...activeCanvasData,
                    shapes: [...updatedShapesData]

                })
            } else {
                setActiveCanvasData({
                    ...activeCanvasData,
                    shapes: [...activeCanvasData.shapes, reactShape]
                })
            }
        } else if (shape.shapeType === "Pin") {
            const id = uuidv4()
            fabric.Image.fromURL(location, function (img) {
                img.scale(0.1).set({
                    type: "Pin",
                    top: deletedItem ? deletedItem ?.top : 100,
                    left: deletedItem ? deletedItem ?.left : 100,
                    angle: 0,
                    id: idValue ? deletedItem.id : id,
                    idImage: deletedItem ? deletedItem ?.idImage : null,
                    title: deletedItem ? deletedItem ?.title : shapeData.title,
                    selectedShape: deletedItem ? { label: shape.shapeType, value: shape.shapeType } : shapeData.selectedShape,
                    hotspot: deletedItem ? deletedItem ?.hotspot : shapeData.hotspot,
                    highlight: false,
                    next: false
                });
                const imgShape = {
                    type: "Pin",
                    top: deletedItem ? deletedItem ?.top : 100,
                    left: deletedItem ? deletedItem ?.left : 100,
                    angle: 0,
                    id: id,
                    idImage: deletedItem ? deletedItem ?.idImage : null,
                    title: deletedItem ? deletedItem ?.title : shapeData.title,
                    selectedShape: deletedItem ? { label: shape.shapeType, value: shape.shapeType } : shapeData.selectedShape,
                    hotspot: deletedItem ? deletedItem ?.hotspot : shapeData.hotspot,
                    highlight: false,
                    next: false
                }
                const shapeTitle = new fabric.Text(imgShape.title, {
                    left: imgShape.left,// + ((shape.aCoords.tr.x-shape.aCoords.tl.x ) / 2),
                    top: imgShape.top -5,
                    fontSize: 20,
                    fontWeight: '600',
                    originX: 'left',
                    originY: 'center',
                });
                shapeTitle.set('selectable', false)


                if (idValue) {
                    // const updatedShapesData = activeCanvasData ?.shapes ?.filter(item => item.id !== idValue)
                    // setActiveCanvasData({
                    //     ...activeCanvasData,
                    //     shapes: [...updatedShapesData, imgShape]
                    // })

                    const updatedShapesData = activeCanvasData ?.shapes ?.map(item => {
                        if(item.id === idValue){
                            return {...imgShape}
                        } else {
                            return {...item}
                        }
                    })
    
                    setActiveCanvasData({
                        ...activeCanvasData,
                        shapes: [...updatedShapesData]
    
                    })
                } else {
                    setActiveCanvasData({
                        ...activeCanvasData,
                        shapes: [...activeCanvasData.shapes, imgShape]
                    })
                }
                var group = new fabric.Group([img,shapeTitle], { ...imgShape })
                canvas.add(group);
            });
        } else if (shape.shapeType === "Arrow") {
            const id = uuidv4()
            fabric.Image.fromURL(arrow, function (img) {
                img.scale(0.065).set({
                    type: "Arrow",
                    top: deletedItem ? deletedItem ?.top : 75,
                    left: deletedItem ? deletedItem ?.left : 75,
                    angle: 0,
                    id: id,
                    padding: 0,
                    idImage: deletedItem ? deletedItem ?.idImage : null,
                    title: deletedItem ? deletedItem ?.title : shapeData.title,
                    selectedShape: deletedItem ? { label: shape.shapeType, value: shape.shapeType } : shapeData.selectedShape,
                    hotspot: deletedItem ? deletedItem ?.hotspot : shapeData.hotspot,
                    highlight: false,
                    next: false
                });
                const imgShape = {
                    type: "Arrow",
                    top: deletedItem ? deletedItem ?.top : 75,
                    left: deletedItem ? deletedItem ?.left : 75,
                    angle: 0,
                    id: idValue ? deletedItem.id : id,
                    padding: 0,
                    idImage: deletedItem ? deletedItem ?.idImage : null,
                    title: deletedItem ? deletedItem ?.title : shapeData.title,
                    selectedShape: deletedItem ? { label: shape.shapeType, value: shape.shapeType } : shapeData.selectedShape,
                    hotspot: deletedItem ? deletedItem ?.hotspot : shapeData.hotspot,
                    highlight: false,
                    next: false
                }
                const shapeTitle = new fabric.Text(imgShape.title, {
                    left: imgShape.left,// + ((shape.aCoords.tr.x-shape.aCoords.tl.x ) / 2),
                    top: imgShape.top -5,
                    fontSize: 20,
                    fontWeight: '600',
                    originX: 'left',
                    originY: 'center',
                });
                shapeTitle.set('selectable', false)
                var group = new fabric.Group([img,shapeTitle], { ...imgShape })


                if (idValue) {
                    // const updatedShapesData = activeCanvasData ?.shapes ?.filter(item => item.id !== idValue)
                    // setActiveCanvasData({
                    //     ...activeCanvasData,
                    //     shapes: [...updatedShapesData, imgShape]
                    // })

                    const updatedShapesData = activeCanvasData ?.shapes ?.map(item => {
                        if(item.id === idValue){
                            return {...imgShape}
                        } else {
                            return {...item}
                        }
                    })
    
                    setActiveCanvasData({
                        ...activeCanvasData,
                        shapes: [...updatedShapesData]
    
                    })
                } else {
                    setActiveCanvasData({
                        ...activeCanvasData,
                        shapes: [...activeCanvasData.shapes, imgShape]
                    })
                }
                canvas.add(group);
            });
        } else if (shape.shapeType === "Build") {
            const id = uuidv4()
            fabric.Image.fromURL(building, function (img) {
                img.scale(0.1).set({
                    type: "Build",
                    top: deletedItem ? deletedItem ?.top : 100,
                    left: deletedItem ? deletedItem ?.left : 100,
                    angle: 0,
                    id: id,
                    idImage: deletedItem ? deletedItem ?.idImage : null,
                    title: deletedItem ? deletedItem ?.title : shapeData.title,
                    selectedShape: deletedItem ? { label: shape.shapeType, value: shape.shapeType } : shapeData.selectedShape,
                    hotspot: deletedItem ? deletedItem ?.hotspot : shapeData.hotspot,
                    highlight: false,
                    next: false
                });
                const imgShape = {
                    type: "Build",
                    top: deletedItem ? deletedItem ?.top : 100,
                    left: deletedItem ? deletedItem ?.left : 100,
                    angle: 0,
                    id: idValue ? deletedItem.id : id,
                    idImage: deletedItem ? deletedItem ?.idImage : null,
                    title: deletedItem ? deletedItem ?.title : shapeData.title,
                    selectedShape: deletedItem ? { label: shape.shapeType, value: shape.shapeType } : shapeData.selectedShape,
                    hotspot: deletedItem ? deletedItem ?.hotspot : shapeData.hotspot,
                    highlight: false,
                    next: false
                }
                const shapeTitle = new fabric.Text(imgShape.title, {
                    left: imgShape.left,
                    top: imgShape.top -5,
                    fontSize: 20,
                    fontWeight: '600',
                    originX: 'left',
                    originY: 'center',
                });
                shapeTitle.set('selectable', false)
                var group = new fabric.Group([img,shapeTitle], { ...imgShape })

                if (idValue) {
                    // const updatedShapesData = activeCanvasData ?.shapes ?.filter(item => item.id !== idValue)
                    // setActiveCanvasData({
                    //     ...activeCanvasData,
                    //     shapes: [...updatedShapesData, imgShape]
                    // })

                    const updatedShapesData = activeCanvasData ?.shapes ?.map(item => {
                        if(item.id === idValue){
                            return {...imgShape}
                        } else {
                            return {...item}
                        }
                    })
    
                    setActiveCanvasData({
                        ...activeCanvasData,
                        shapes: [...updatedShapesData]
    
                    })
                } else {
                    setActiveCanvasData({
                        ...activeCanvasData,
                        shapes: [...activeCanvasData.shapes, imgShape]
                    })
                }
                canvas.add(group);
            });
        } else {
            var node = new fabric.Circle({
                radius: 20,
                fill: '#fd3d3d',
                left: 0,
                stroke: "#fd3d3d",
                top: 30,
                strokeWidth: 1,
            });

            const nodeShape = {
                type: "node",
                top: deletedItem ? deletedItem ?.top : 150,
                left: deletedItem ? deletedItem ?.left : 100,
                id: idValue ? deletedItem.id : uuidv4(),
                idImage: deletedItem ? deletedItem ?.idImage : null,
                title: deletedItem ? deletedItem ?.title : shapeData?.title,
                opacity: deletedItem?.opacity ? deletedItem?.opacity : 1,
                fill: deletedItem?.fill ? deletedItem?.fill : '#fd3d3d',
                stroke: deletedItem?.stroke ? deletedItem?.stroke : '#fd3d3d',
                selectedShape: deletedItem ? { label: shape.shapeType, value: shape.shapeType } : shapeData?.selectedShape,
                hotspot: deletedItem ? deletedItem ?.hotspot : shapeData?.hotspot,
                highlight: false,
                next: false,
                scaleX: 1,
                scaleY: 1,
                aCoords: {
                    tl: { x: 101.50417827298051, y: 150 },
                    tr: {
                        x: 145.5041782729805, y: 150
                    },
                    bl: { x: 101.50417827298051, y: 194 },
                    br: { x: 145.5041782729805, y: 194 }
                },
                angle: 0,

            }
            const shapeTitle = new fabric.Text(nodeShape?.title || '' , {
                left: node.left,
                top: node.top-5,
                fontSize: 20,
                fontWeight: '600',
                originX: 'left',
                originY: 'center',
            });
            
            var group = new fabric.Group([node,shapeTitle], { ...nodeShape })

            canvas.add(group);

            if (idValue) {
                const updatedShapesData = activeCanvasData ?.shapes ?.map(item => {
                    if(item.id === idValue){
                        return {...nodeShape}
                    } else {
                        return {...item}
                    }
                })

                setActiveCanvasData({
                    ...activeCanvasData,
                    shapes: [...updatedShapesData]

                })
            } else {
                setActiveCanvasData({
                    ...activeCanvasData,
                    shapes: [...activeCanvasData.shapes, nodeShape]
                })
            }

            canvas.renderAll();

        }
        setShapeData(null)
    }

    const addShapeImgHandler = (index, img) => {
        const updatedShapes = activeCanvasData.shapes.map((itemData, itemIndex) => {
            if (itemIndex === index) {
                setChangedShape({
                    ...itemData,
                    idImage: { ...img }
                })
                return {
                    ...itemData,
                    idImage: { ...img }
                }
            } else {
                return itemData
            }
        })
        setActiveCanvasData({ ...activeCanvasData, shapes: [...updatedShapes] })
    }

    const moveHander = async (imgData, title, hotspot) => {
        const isExist = modeData.images.find(item => imgData.id === item.id)
        let updatedModeData
        if (!isExist) {
            updatedModeData = [...modeData.images, {
                comesForm: {
                    id: activeCanvasData.id,
                    path: activeCanvasData.path,
                },
                title: hotspot.name,
                constrains: {
                    ...hotspot
                },
                id: imgData.id,
                path: imgData.path,
                shapes: []
            }]
        } else {
            updatedModeData = modeData.images.map(img => {
                if (img.id === imgData.id) {
                    return {
                        ...img,
                        comesForm: {
                            id: activeCanvasData.id,
                            path: activeCanvasData.path,
                        },
                        constrains: {
                            ...hotspot
                        },
                        title: hotspot.name,
                    }
                } else {

                    return img
                }
            })
        }
        dispatch(appendData({
            ...modeData,
            currentImge: {
                id: imgData ?.id,
                path: imgData ?.path,
            },
            previousImg: {
                id: activeCanvasData ?.id,
                path: activeCanvasData ?.path,
            },
            images: [...updatedModeData]
        }
        ))
        setTitles([])
        setSelectedAll(false)
    }

    const addShapeHandlerUpdated = (canvas, shape, id, values) =>{
        canvas.forEachObject(function (obj) {
            if (obj.id && obj.id === id) canvas.remove(obj);
        });

        if (shape?.type === "Cubic") {
            const reactShape = {
                ...shape,
                opacity: values.opacity,
                fill: values?.fill,
                stroke: values.fill
            }
            var rect = new fabric.Rect(reactShape);
            const shapeTitle = new fabric.Text(reactShape.title, {
                left: reactShape.left,
                top: reactShape.top-5,
                fontSize: 20,
                fontWeight: '600',
                originX: 'left',
                originY: 'center',
            });
            shapeTitle.set('selectable', false)
                    
            var group = new fabric.Group([rect,shapeTitle], { ...reactShape })
            canvas.add(group)
        } else if(shape?.type === 'node'){
            var node = new fabric.Circle({
                radius: 20,
                fill: values?.fill,
                left: 0,
                stroke: values?.fill,
                top: 30,
                strokeWidth: 1,
            });

            const nodeShape = {
                ...shape,
                opacity: values.opacity,
                fill: values?.fill,
                stroke: values.fill
            }
            const shapeTitle = new fabric.Text(nodeShape?.title , {
                left: node.left,
                top: node.top-5,
                fontSize: 20,
                fontWeight: '600',
                height: 7.5,
                originX: 'left',
                originY: 'center',
            });
            
            var group = new fabric.Group([node,shapeTitle], { ...nodeShape })

            canvas.add(group);
        }
        canvas.renderAll();
                            
    }

    const removeSpot = (canvas, id, type) => {
        canvas.forEachObject(function (obj) {
            if (obj.id && obj.id === id) canvas.remove(obj);
        });

        addShapeHandler({
            shapeType: type
        }, id)
    }

    const canvasRef = useRef();

    const handleDrop = (e) => {
        e.preventDefault();
        if(titles.length > 0){
            titles?.map(res=> setTimeout(()=>{dragItems(res, e)},500))
        } 
        setTitles([])
        setSelectedAll(false)
    };

    const handleDragOver = e => {
        e.preventDefault();
    };

    function dragItems(hotspot, e){
        if(layer){
            return toast.error('Remove Layer First')
        }
        let id = uuidv4()
        let top = e?.nativeEvent?.layerY - 35
        let left = e?.nativeEvent?.layerX -25
        const nodeShape = {
            type: "node",
            left: left,
            top: top,
            id: id,
            idImage: null,
            title: hotspot?.name,
            opacity: 1,
            fill: '#fd3d3d',
            stroke: '#fd3d3d',
            selectedShape: { label: 'node', value: 'node' },
            hotspot: hotspot,
            highlight: true,
            next: false,
            scaleX: 1,
            scaleY: 1,
            angle: 0,
            // width: 50,
        }
        var node = new fabric.Circle({
            radius: 20,
            // fill: '#fd3d3d',
            // // left: 0,
            // stroke: "#fd3d3d",
            // // top: 30,
            // strokeWidth: 1,
            ...nodeShape
        });


        const shapeTitle = new fabric.Text(hotspot.name , {
            left: node.left,// + node.width / 2,
            top: node.top - 10,
            fontSize: 20,
            fontWeight: '600',
            originX: 'left',
            originY: 'center',
        });
        var group = new fabric.Group([node, shapeTitle], { ...nodeShape })
        canvas.add(group);
        canvas.renderAll();
    }

    useEffect(()=> setShow(true),[])

    return (
        <>
            {show && <Row style={{ minHeight: "320px", padding: 0, borderRadius: "20px", background: "#a6a8a2", marginLeft: "10px", overflow: "hidden", justifyContent: 'space-between' }}>
                <Col md={3} sm={12} className="d-flex justify-content-center p-0  " >
                    <img src={activeCanvasData ?.path} draggable={false} style={{
                        width: "100%",
                        height: "100%",
                        filter: "blur(10px)",
                    }} />
                    <ul className="position-absolute bg-light px-3 py-4 newScroll btnGroupInteractive" 
                        style={{listStyle: 'none', borderRadius: '8px', 
                                top:'50%', left: '51%', width: '105%',
                                height:'103%', overflow: 'auto',
                                transform: 'translate(-50%, -50%)'}}>
                        {customizeTypes(activeCanvasData ?.constrains) && <div className="">
                                <button className={`btn font-size-12 w-100 mb-3 ${changeType ? 'btn btnInteractive' : 'btn-primary'}`}
                                        style={{padding: '8px'}}
                                        onClick={()=> {
                                            setSelectedAll(false)
                                            setTitles([])
                                            setChangeType(false)
                                        }}
                                >Standalone Properties</button>
                                <button className={`btn font-size-12 w-100 mb-3 ${!changeType ? 'btn btnInteractive' : 'btn-primary'}`}
                                        style={{padding: '8px'}}
                                        onClick={()=> {
                                            setSelectedAll(false)
                                            setTitles([])
                                            setChangeType(true)
                                        }}
                                >Buildings</button>
                        </div>}

                        {(customizeTypes(activeCanvasData ?.constrains) ? hotspots?.filter(obj1 => !activeCanvasData.shapes.some(obj2 => obj2.hotspot?.id === obj1.id ))?.filter(res=> res.value !== 'none' && changeType ? res.type == 'building' : res.type == 'unit')?.length > 0 : unitHotspot.filter(res=> res.value !== 'layer').length > 0) && 
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="selectAll">
                                    <input type="checkbox" className="me-2 " id='selectAll' onChange={(e)=> {
                                        let all = []
                                        if(customizeTypes(activeCanvasData ?.constrains)){
                                            all = hotspots?.filter(res=> res.value !== 'none' && changeType ? res.type == 'building' : res.type == 'unit')
                                        } else{
                                            all = unitHotspot?.filter(res=> res.value !== 'none')
                                        }
                                        
                                        setTitles(e.target.checked ? all : [])
                                        setSelectedAll(e.target.checked)
                                        }} checked={selectedAll} />
                                    <label htmlFor='selectAll' className="font-font-size-16">Select All</label>
                                </div>
                                {(!changeType && customizeTypes(activeCanvasData ?.constrains)) && <Dropdown className={`dropdownWidth`} color="light" isOpen={dropdownMasterOpen} toggle={toggleMaster}>
                                        <DropdownToggle caret>
                                            <i className="fas fa-ellipsis-h  text-dark fa-lg"></i>
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            <DropdownItem 
                                            onClick={() => {
                                                if(titles.length == 0){
                                                    toast.error('Select Units First')
                                                    return
                                                }
                                                toggleAddToBuildingModal()
                                            }} >Add to Building</DropdownItem>
                                        </DropdownMenu>
                                </Dropdown>}
                        </div>}

                        {customizeTypes(activeCanvasData ?.constrains) ? hotspots?.filter(obj1 => !activeCanvasData.shapes.some(obj2 => obj2.hotspot?.id === obj1.id ))?.filter(res=> res.value !== 'none' && changeType ? res.type == 'building' : res.type == 'unit')?.length == 0 ? <>
                            {changeType ? <p>There's no buildings to added in this compound</p> : <p>There's no standalone properties to added in this compound</p>}
                        </> : hotspots?.filter(obj1 => !activeCanvasData.shapes.some(obj2 => obj2.hotspot?.id === obj1.id ))?.filter(res=> res.value !== 'none' && changeType ? res.type == 'building' : res.type == 'unit')?.map((item,index) => {
                            return <li className="font-size-14" key={item?.id}
                                style={{padding:'9px 3px 0px 5px',marginTop : '0rem',paddingTop:'0.5rem'}}
                                draggable={true} 
                                onDragStart={()=> {
                                    if(titles.length > 0){
                                        let update = titles?.filter(res=> res?.label == item?.label)
                                        if(!update.length){
                                            let update = titles?.filter(res=> res?.label !== item?.label)
                                            setSelectedAll(false)
                                            setTitles([...update])
                                        }
                                    } else{
                                        setTitles([item])
                                    }
                                    // setTitle(item)
                                }}
                                >
                                    <input type="checkbox" id={`item-${index}`}
                                        className="me-2" onChange={(e)=> {
                                        if(titles.length > 0){
                                            if(e.target.checked){
                                                setTitles([...titles, item])
                                            }else{
                                                let update = titles?.filter(res=> res?.label !== item?.label)
                                                setSelectedAll(false)
                                                setTitles([...update])
                                            }
                                        } else{
                                            setTitles([item])
                                        }
                                        }} checked={ titles.length > 0 ? titles?.filter(res=> res?.label == item?.label)?.length : false}/>
                                    <label style={{width: 'calc(100% - 21px)'}} htmlFor={`item-${index}`}>{item.id}. <span style={{fontWeight:"700", marginLeft:'5px'}}>{item.name}</span></label>
                            </li>}) : unitHotspot.filter(res=> res.value !== 'layer')?.length == 0 ? <p>There's no properties to added in this building</p> : unitHotspot.filter(res=> res.value !== 'layer')?.map((item,index) => {
                            return  <li className="font-size-14" key={item?.id}
                                style={{padding:'9px 3px 0px 5px',marginTop : '0rem',paddingTop:'0.5rem'}}
                                draggable={true} 
                                onDragStart={()=> {
                                    if(titles.length > 0){
                                        let update = titles?.filter(res=> res?.label == item?.label)
                                        if(!update.length){
                                            let update = titles?.filter(res=> res?.label !== item?.label)
                                            setSelectedAll(false)
                                            setTitles([...update])
                                        }
                                    } else{
                                        setTitles([item])
                                    }
                                    // setTitle(item)
                                }}
                                >
                                    <input type="checkbox" id={`item-${index}`}
                                        className="me-2" onChange={(e)=> {
                                        if(titles.length > 0){
                                            if(e.target.checked){
                                                setTitles([...titles, item])
                                            }else{
                                                let update = titles?.filter(res=> res?.label !== item?.label)
                                                setSelectedAll(false)
                                                setTitles([...update])
                                            }
                                        } else{
                                            setTitles([item])
                                        }
                                        }} checked={titles.length > 0 ? titles?.filter(res=> res?.label == item?.label)?.length : false}/>
                                    <label style={{width: 'calc(100% - 21px)'}} htmlFor={`item-${index}`}>{item.id}. <span style={{fontWeight:"700", marginLeft:'5px'}}>{item.name}</span></label>
                            </li>})}
                    </ul>
                </Col>
                <Col md={1}>
                    <img src={activeCanvasData ?.path} draggable={false} style={{
                        width: "100%",
                        height: "100%",
                        filter: "blur(10px)",
                    }} />

                    {modeData.masterImg.id !== activeCanvasData.id && <button
                        onClick={() => {
                            const updatedList = headerList.filter(item => {
                                if (item.id !== activeCanvasData.id) {
                                    return true
                                } else {
                                    return false
                                }
                            })
                            setHeaderList([...updatedList])
                            dispatch(appendData({
                                currentImge: activeCanvasData.comesForm,
                            }
                            ))

                        }}
                        style={{ position: "absolute", 
                                top: "50%", left: "45%", transform: 'translate(-50%, -50%)',
                                width: "40px", height: "40px",
                                background: "none", border: "none", outline: "none", }}>
                        <i className="fas fa-arrow-left font-size-18 slider-icon "  ></i>
                    </button>}
                </Col>
                <Col md={7} sm={12} style={{ padding: "18px 0" }} className="d-flex justify-content-center ">
                    {activeCanvasData.path.length ? <div onDragOver={handleDragOver}
                        onDrop={handleDrop}>
                        <canvas id={`canvas`} 
                        ref={canvasRef}
                        style={{ border: "1px solid rgba(0,0,0,0)", 
                                borderRadius: "5px", overflow: "hidden" }}
                    ></canvas></div> : null }
                </Col>
                <Col md={1} sm={12} className="d-flex justify-content-center p-0" >
                    <img src={activeCanvasData ?.path} draggable={false} style={{
                        width: "100%",
                        height: "100%",
                        filter: "blur(10px)",
                    }} />

                    <button
                        onClick={() => {
                            const selectedNode = activeCanvasData.shapes.find((shape) => shape.next === true)
                            if (selectedNode) {
                                if (!selectedNode.idImage) {
                                    toast.error("upload photo  First")
                                } else if (!selectedNode ?.hotspot ?.id) {

                                    toast.error("Select hotspot type ")
                                    return
                                } else {
                                    let { idImage, hotspot, title } = selectedNode
                                    moveHander(idImage, title, hotspot)
                                    // dispatch(appendData({
                                    //     currentImge: { ...selectedNode.idImage }
                                    // }))
                                    const updatedList = [...headerList, selectedNode.idImage]

                                    setHeaderList([...updatedList])
                                    window.scrollTo({
                                        top: 0,
                                        behavior: 'smooth'
                                    })
                                }
                            } else {
                                const selectedDefaultNode = activeCanvasData.shapes.find((shape, index) => index === 0)
                                if (!selectedDefaultNode.idImage) {
                                    toast.error("upload photo First")
                                    return
                                } else if (!selectedDefaultNode?.hotspot?.id) {
                                    toast.error("Select hotspot type ")
                                    return
                                } 
                                let { idImage, hotspot, title } = selectedDefaultNode
                                moveHander(idImage, title, hotspot)
                                const updatedList = [...headerList, idImage]

                                setHeaderList([...updatedList])
                                window.scrollTo({
                                    top: 0,
                                    behavior: 'smooth'
                                })
                            }
                        }}
                        style={{ position: "absolute", 
                                top: "50%", left: "40%", transform: 'translate(-50%, -50%)',
                                width: "40px", height: "40px", background: "none", 
                                border: "none", outline: "none", }}>
                        <i className="fas fa-arrow-right font-size-18 slider-icon" ></i>
                    </button>
                </Col>
            </Row>}

            {activeCanvasData ?.shapes.map((item, index) => {
                return (
                    <Shape
                        key={index}
                        index={index}
                        item={item}
                        titles={titles}
                        buildingErrors={buildingErrors}
                        setHeaderList={setHeaderList}
                        headerList={headerList}
                        radioChangeHandler={(e) => {
                            const updatedShapes = activeCanvasData.shapes.map((itemData, itemIndex) => {
                                if (itemIndex === index) {
                                    return {
                                        ...itemData,
                                        next: true
                                    }
                                } else {
                                    return {
                                        ...itemData,
                                        next: false
                                    }
                                }
                            })

                            setActiveCanvasData({ ...activeCanvasData, shapes: [...updatedShapes] })
                        }}
                        addBuilding={(name, edit)=> {
                            let data ={
                                compound_id: modeData?.compound.value,
                                name: {en: name || null}
                            }
                            let isEdit = edit.hasOwnProperty('id')
                            new BuildingService().checkBuilding({ compound_id: modeData?.compound.value, name: name }).then(res=>{
                                if(!res.data){
                                    if(isEdit){
                                        new BuildingService().update(edit?.id, data).then(response => {
                                            if (response && response.status === SuccessOk) {
                                                let building = {
                                                    name: name,
                                                    label: `${name} / Building`,
                                                }
                                                const updatedShapes = activeCanvasData.shapes.map((itemData, itemIndex) => {
                                                    if (itemIndex === index) {
                                                        return {
                                                            ...itemData,
                                                            hotspot: {...itemData.hotspot,...building}
                                                        }
                                                    } else {
                                                        return itemData
                                                    }
                                                })
                                                setActiveCanvasData({ ...activeCanvasData, shapes: [...updatedShapes] })
                                            } 
                                        })
                                    } else {
                                        new BuildingService().create(data).then(response => {
                                            if (response && response.status === SuccessCreated) {
                                                let building = {
                                                    name: name, 
                                                    label: `${name} / Building`, 
                                                    id: response.data[0], 
                                                    type:'building',
                                                }
                                                setDefaultHotspots([...defaultHotspots, building])
                                                const updatedShapes = activeCanvasData.shapes.map((itemData, itemIndex) => {
                                                    if (itemIndex === index) {
                                                        return {
                                                            ...itemData,
                                                            hotspot: {...itemData.hotspot,...building}
                                                        }
                                                    } else {
                                                        return itemData
                                                    }
                                                })
                                                setActiveCanvasData({ ...activeCanvasData, shapes: [...updatedShapes] })
                                            } 
                                        })
                                    }
                                } else {
                                    setBuildingErrors({...buildingErrors, [name]: true})
                                }
                            })
                            
                            initCanvas()
                        }}
                        changeNodeOpacity={(value)=> {
                            let shape = {}
                            const updatedShapes = activeCanvasData.shapes.map((itemData, itemIndex) => {
                                if (itemIndex === index) {
                                    shape = itemData
                                    return {
                                        ...itemData,
                                        opacity: value,
                                        next: true
                                    }
                                } else {
                                    return {
                                        ...itemData,
                                        next: false
                                    }
                                }
                            })

                            addShapeHandlerUpdated(canvas, shape, shape.id, {opacity: value, fill: shape?.fill});

                            setActiveCanvasData({ ...activeCanvasData, shapes: [...updatedShapes] })
                        }}
                        changeNodeColor={(color)=> {
                            let shape = {}
                            const updatedShapes = activeCanvasData.shapes.map((itemData, itemIndex) => {
                                if (itemIndex === index) {
                                    shape = itemData
                                    return {
                                        ...itemData,
                                        fill: color,
                                        next: true
                                    }
                                } else {
                                    return {
                                        ...itemData,
                                        next: false
                                    }
                                }
                            })

                            addShapeHandlerUpdated(canvas, shape, shape.id, {opacity: shape.opacity, fill: color});

                            setActiveCanvasData({ ...activeCanvasData, shapes: [...updatedShapes] })
                        }}
                        updateFloor={(floor)=> {
                            if(!floor.target.value){
                                return
                            }
                            let data ={
                                floor: parseInt(floor.target.value)
                            }
                            new PropertyService().update(item.hotspot.id, data).then(response => {
                                if (response && response.status === SuccessOk) {
                                    const updatedShapes = activeCanvasData.shapes.map((itemData, itemIndex) => {
                                        if (itemIndex === index) {
                                            return {
                                                ...itemData,
                                                hotspot: {...itemData.hotspot, ...data}
                                            }
                                        } else {
                                            return itemData
                                        }
                                    })
                                    setActiveCanvasData({ ...activeCanvasData, shapes: [...updatedShapes] })
                                } 
                            })
                        }}
                        selectAllHandler={(e) => {
                            const updatedShapes = activeCanvasData.shapes.map((itemData, itemIndex) => {
                                return {
                                    ...itemData,
                                    highlight: e
                                }
                            })
                            setActiveCanvasData({ ...activeCanvasData, shapes: [...updatedShapes] })
                        }}
                        checkboxChangeHandler={(e, type) => {
                            if (!item ?.highlight) {
                                canvas.setActiveObject(canvas.item(index));
                                canvas.requestRenderAll()

                            }
                            const updatedShapes = activeCanvasData.shapes.map((itemData, itemIndex) => {
                                if (itemIndex === index) {
                                    return {
                                        ...itemData,
                                        highlight: !itemData.highlight
                                    }
                                }  else {
                                    return {
                                        ...itemData
                                    }
                                }
                            })
                            setActiveCanvasData({ ...activeCanvasData, shapes: [...updatedShapes] })
                        }}
                        titleHandler={(e) => {
                            const updatedShapes = activeCanvasData.shapes.map((itemData, itemIndex) => {
                                if (itemIndex === index) {
                                    delete buildingErrors[itemData.title]
                                    setBuildingErrors({...buildingErrors})
                                    return {
                                        ...itemData,
                                        title: e.target.value,
                                        hotspot:{ 
                                            ...itemData.hotspot,
                                            name: e.target.value,
                                        }
                                    }
                                } else {
                                    return itemData
                                }
                            })
                            setActiveCanvasData({ ...activeCanvasData, shapes: [...updatedShapes] })

                        }}
                        shapeTypeHandler={data => {
                            removeSpot(canvas, item.id, data.label);
                        }}
                        addSelectedUnit={addSelectedUnit}
                        hotspotTypeHandler={(data) => {
                            const updatedShapes = activeCanvasData.shapes.map((itemData, itemIndex) => {
                                if (itemIndex === index) {

                                    if (itemData ?.idImage ?.fromLibrary) {
                                        return {
                                            ...itemData,
                                            hotspot: data,
                                            idImage: null
                                        }
                                    } else {
                                        return {
                                            ...itemData,
                                            hotspot: data
                                        }
                                    }

                                } else {
                                    return itemData
                                }
                            })
                            setActiveCanvasData({ ...activeCanvasData, shapes: [...updatedShapes] })
                        }}
                        customizeTypesHandler={customizeTypes(activeCanvasData ?.constrains) ? hotspots : defaultUnitHotspot.filter((value) => !activeCanvasData.shapes.some(item => item ?.hotspot?.name === value.name))}
                        addShapeImgHandler={addShapeImgHandler}
                        removeShapeHandler={async () => {
                            canvas.forEachObject(function (obj) {
                                if (obj.id && obj.id === item.id) canvas.remove(obj);
                            });
                            let target = item.idImage?.id
                            let deletedList = [target]
                            const imagesData = modeData.images
                            for (let i = 0; i < imagesData.length; i++) {
                                const item = imagesData[i]
                                if (deletedList.findIndex(deleteItem => deleteItem === item.id) >= 0) {
                                    for (let k = 0; k < item.shapes.length; k++) {
                                        const shape = item.shapes[k];
                                        deletedList.push(shape?.idImage?.id)
                                    }
                                }
                            }
                            if(item?.hotspot?.value == 'addBuilding'){
                                let res = await propertyService.getDropDown(item?.hotspot?.id)
                                if(!res.data?.length){
                                    new BuildingService().remove(item?.hotspot?.id)
                                }
                            }
                            const updatedImages = modeData.images.filter(img => !deletedList.some(imgdata => imgdata === img.id))
                            dispatch(appendData({ images: updatedImages }))
                            const updatedShapesData = activeCanvasData ?.shapes ?.filter(itemData => itemData.id !== item.id)
                            setActiveCanvasData({
                                ...activeCanvasData,
                                shapes: [...updatedShapesData]
                            })
                            delete buildingErrors[item.title]
                            setBuildingErrors({...buildingErrors})

                            canvas.requestRenderAll();
                            setShouldGetData((prev) => !prev)
                        }}
                        removeMoreShapeHandler={() => {
                            let update = activeCanvasData ?.shapes?.filter(item=> item.highlight)
                            if(update.length == 0){
                                toast.error('Select First')
                                return
                            }
                            let deletedList = []
                            const imagesData = modeData.images
                            
                            update?.map(item=>{
                                canvas.forEachObject(function (obj) {
                                    if (obj.id && obj.id === item.id) canvas.remove(obj);
                                });
                                let target = item.idImage?.id
                                deletedList.push(target)
                                for (let i = 0; i < imagesData.length; i++) {
                                    const item = imagesData[i]
                                    if (deletedList.findIndex(deleteItem => deleteItem === item.id) >= 0) {
                                        for (let k = 0; k < item.shapes.length; k++) {
                                            const shape = item.shapes[k];
                                            deletedList.push(shape.idImage?.id)
                                        }
                                    }
                                }
                                if(item.hotspot?.value == 'addBuilding'){
                                    let res = propertyService.getDropDown(item?.hotspot?.id)
                                    if(!res.data?.length){
                                        new BuildingService().remove(item?.hotspot?.id)
                                    }
                                }
                            })
                            let updatedShapesData = activeCanvasData?.shapes?.filter(itemData => !itemData.highlight)

                            const updatedImages = modeData.images.filter(img => !deletedList.some(imgdata => imgdata === img.id))
                            dispatch(appendData({ images: updatedImages }))
                            setActiveCanvasData({
                                ...activeCanvasData,
                                shapes: [...updatedShapesData]
                            })
                            canvas.requestRenderAll();
                            setShouldGetData((prev) => !prev)
                        }}
                        moveHander={moveHander}
                        toggleUnitModal = {()=>{
                            let isExist = activeCanvasData.shapes?.some(item=> !item.idImage && item.highlight)
                            if(isExist){
                                return toast.error('Upload Main Image First')
                            } else{
                                setUploadUnitImagesModal(true)
                            }
                        }}
                        toggleMainImageModal = {()=>{
                            let isExist = activeCanvasData.shapes?.filter(item=> item.highlight)
                            if(isExist.length ==0){
                                return toast.error('Select First')
                            }else{
                                toggleUploadMainModal()
                            }
                        }}
                    />
                )
            })}

            {!!shapeData ?
                <Row className="mt-4">
                    <Col sm={12} md={1}></Col>
                    <Col sm={12} md={3}>
                        <AvForm >
                            <AvField
                                name='ar'
                                className='form-control'
                                placeholder={"Phase Name"}
                                label={"Title"}
                                onChange={(e) => {
                                    if(shapeData.hotspot?.value === 'none'){
                                        setShapeData({ ...shapeData, title: e.target.value })
                                    }
                                }}
                                bsSize="lg"
                                value={shapeData.title}
                                disabled={shapeData.hotspot?.value !== 'none' ? true : false}
                            />
                        </AvForm>
                    </Col>

                    <Col sm={12} md={3}>
                        <label>Shape Type</label>
                        <Select
                            placeholder='Select'
                            options={shapes}
                            className='mb-3 '
                            onChange={data => {
                                setShapeData({ ...shapeData, selectedShape: data })
                            }}
                            value={shapeData.selectedShape}
                        />
                    </Col>
                    <Col sm={12} md={3}>
                        <label>Hotspot Type</label>
                        <Select
                            placeholder='Select'
                            options={customizeTypes(activeCanvasData ?.constrains) ? hotspots : layer ? [{label:'Layer', value: 'layer', name: 'layer', type: 'layer', id: activeCanvasData?.constrains?.id}]: [...unitHotspot]}
                            onChange={(data) => {
                                if(data?.value === 'none'){
                                    return setShapeData({ ...shapeData, hotspot: data})
                                }
                                setShapeData({ ...shapeData, hotspot: data, title: data.name })
                            }}
                            value={shapeData.hotspot}
                        />
                    </Col>
                    
                    <Col sm={12} md={1}  >
                        <Label>Action</Label>
                        <button style={{ fontSize: "0.92rem" }}
                            className="btn btn-white border-light border-2 py-2 px-4 " onClick={() => {
                                toast.error("Complete Shape Data")
                            }}>Next</button>
                    </Col>
                    <Col sm={12} md={1}>
                        <Label></Label>
                        <Dropdown className="dropdownWidth mt-2 mx-4" color="light" isOpen={shapeDropdownOpen} toggle={shapeToggle}>
                            <DropdownToggle caret>
                                <i className="fas fa-ellipsis-h  text-dark fa-lg"></i>
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem className="text-danger"
                                    onClick={() => {
                                        setShapeData(null)
                                    }}>Remove Hotspot</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </Col>
                </Row> : null}
            <Row className="m-0 p-0">
                {activeCanvasData.shapes.length === 0 && !shapeData ? <Col md={12} className="mt-4 " style={{ textAlign: 'center' }}  >
                    <h5>No Hotspot Available</h5>
                    <h5 >Please Add New Hotspot and start</h5>
                    {activeCanvasData.constrains?.label !== 'Layer' && <button className="btn btn-primary me-2 px-3" onClick={() => setShapeData({
                        idImage: null,
                        path: "",
                        title: "",
                        selectedShape: null,
                        hotspot: null
                    })}> + Add New Hotspot </button>}
                    {customizeTypes(activeCanvasData ?.constrains) && <button className="btn btn-light px-3" onClick={() => setShapeData({
                              idImage: null,
                              path: "",
                              title: "",
                              selectedShape: {label: 'node', value: 'node'},
                              hotspot: {
                                label: 'Building',
                                value: 'addBuilding',
                                type: 'building'
                                }
                          })}> + Add New Building </button>}
                </Col> :
                    <Col md={12} className="d-flex flex-lg-row-reverse mt-4 me-0 pe-0">
                        {customizeTypes(activeCanvasData ?.constrains) && <button className="btn btn-light mt-0 mb-4" onClick={() => setShapeData({
                              idImage: null,
                              path: "",
                              title: "",
                              selectedShape: {label: 'node', value: 'node'},
                              hotspot: {
                                label: 'Building',
                                value: 'addBuilding',
                                type: 'building'
                                }
                          })}> + Add New Building </button>}
                        {(activeCanvasData?.constrains?.label !== 'Layer' || activeCanvasData?.shapes?.some(shape => shape.hotspot.type !== 'unit')) && <button className="btn btn-primary me-2 mt-0 mb-4" onClick={() => setShapeData({
                            idImage: null,
                            path: "",
                            title: "",
                            selectedShape: null,
                            hotspot: null
                        })}> + Add New Hotspot </button>}
                    </Col>
                }
            </Row>
            {addToBuildingModal && <AddToBuildingModal
                modal={addToBuildingModal}
                toggle={toggleAddToBuildingModal}
                compound_id={modeData.compound?.value}
                ids={[...titles?.map(item => item?.id)]}
                setShouldGetData={setShouldGetData}
                options={[...hotspots?.filter(res=> res.value !== 'none' && res.type == 'building'), ...activeCanvasData.shapes?.map(item=> item.hotspot)]}
            />}
            
            {uploadUnitImagesModal && <UploadUnitImagesModal
                modal={uploadUnitImagesModal} 
                toggle={toggleUnitModal} 
                activeCanvasData={activeCanvasData}
                ids={[...activeCanvasData?.shapes?.filter(item=> item.highlight)?.map(res=> res.hotspot)]}
            />}
            {uploadMainImageModal && 
                <UploadMainImageModal
                    image = {!activeCanvasData?.shapes?.some(item=> !item.idImage && item.highlight) ? activeCanvasData?.shapes?.filter(item=> item.highlight)[0].idImage : null}
                    setActiveCanvasData= {setActiveCanvasData}
                    modal={uploadMainImageModal} 
                    activeCanvasData={activeCanvasData}
                    toggle={toggleUploadMainModal}/>
            }
        </>
    )
}

let validate = (str) => {
    let count = 0
    for (let i = 0; i < str.length; i++) {
        if ((str.charCodeAt(i) >= 65 && str.charCodeAt(i) <= 90) || (str.charCodeAt(i) >= 97 && str.charCodeAt(i) <= 122)) {
            count += 1
        }
    }

    return count >= 2 ? true : false

}
export default FabricCanvas